import Button from "common/components/Button/Button"
import DireccionInputs from "common/components/FormikFields/DireccionInputs"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import * as Validations from "common/utils/formValidations"
import { getDefaultCountry } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { createDireccionEmpresa } from "features/User/redux/slices/empresaSlice"
import { userSelector } from "features/User/redux/slices/userSlice"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useHistory } from "react-router-dom"
import * as Yup from "yup"

const Direccion = ({
  setFieldValue,
  handleSubmit,
  values,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const history = useHistory()
  const businessCountry = useSelector(getDefaultCountry)

  return (
    <form onSubmit={handleSubmit}>
      <small className='p-error p-d-block'>
        {t("crear.facturaRec.modal.notDirectionMsg")}
      </small>

      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='direccionInput'>
            {t("crear.facturaRec.modal.directionLabel")}
          </label>

          <FormikInputText
            id='direccionInput'
            name='calle'
          />
        </div>
      </div>

      <div className='mb-2 p-fluid'>
        <DireccionInputs
          initialCodigoPostal={values.codigoPostal}
          cpName='codigoPostal'
          setFieldValue={setFieldValue}
          otherCountries={businessCountry !== DEFAULT_COUNTRY_SELECTED}
          countrySelected={businessCountry}
          cpValue={values.cp}
          poblacionValue={values.poblacion}
        />
      </div>

      <input
        type='text'
        autoComplete='on'
        value=''
        style={{
          display: "none",
          opacity: 0,
          position: "absolute",
          left: "-100000px",
        }}
        readOnly
      />

      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <Button
            className='mr-2 outlined'
            onClick={() => history.goBack()}
          >
            {t("crear.facturaRec.modal.goBackLabel")}
          </Button>

          <Button
            className='!tw-bg-primary'
            type='submit'
          >
            {t("crear.facturaRec.modal.nextLabel")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validateForm = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    poblacion: Yup.string().when("pais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: Validations.validatePoblacion(t),
    }),
    poblacionId: Yup.string().when("pais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: Yup.string().required(),
    }),
    codigoPostal: Yup.string().when("pais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: Validations.validateCodigoPostal(t),
    }),
    calle: Yup.string().when("pais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: Validations.validateDireccion(t),
    }),
  })

const mapValuesToApi = (
  values: $TSMigrationFixMe,
  direccion: $TSMigrationFixMe
) => {
  let auxMappedDirection = {
    calle: values?.calle,
    codigoPostal: values?.codigoPostal,
    isFiscal: 1,
    empresaId: direccion.id,
  }

  if (values.pais === DEFAULT_COUNTRY_SELECTED) {
    auxMappedDirection = {
      ...auxMappedDirection,
      // @ts-expect-error TS(2322): Type '{ poblacionId: $TSFixMe; poblacion: $TSFixMe; calle: a...
      poblacionId: values.poblacionId,
      poblacion: values.poblacion,
    }
  } else {
    auxMappedDirection = {
      ...auxMappedDirection,
      // @ts-expect-error TS(2322): Type '{ poblacionExtranjera: $TSFixMe; calle: $TSFixMe; codi...
      poblacionExtranjera: values.poblacionExtranjera,
    }
  }
  return auxMappedDirection
}

const DireccionWithFormik = withFormik({
  validationSchema: ({ t }: $TSMigrationFixMe) => validateForm(t),
  // @ts-expect-error TS(2339): Property 'direccion' does not exist on type '{}'.
  mapPropsToValues: ({ direccion, pais }) => ({
    codigoPostal: direccion.cp || "",
    calle: direccion.direccion || "",
    poblacion: "",
    poblacionId: "",
    poblacionExtranjera: direccion.poblacionExtranjera || "",
    pais,
  }),
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'props' does not exist on type '{}'.
  validate: (values, { props }) => {
    const errors = {}
    if (!values.poblacionId && values.pais === DEFAULT_COUNTRY_SELECTED) {
      // @ts-expect-error TS(2339): Property 'poblacion' does not exist on type '{}'.
      errors.poblacion = `${props.t("errors.selectedPoblation")}`
    }
    return errors
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    // @ts-expect-error TS(2339): Property 'direccion' does not exist on type 'objec...
    const data = mapValuesToApi(values, props.direccion)
    setSubmitting(true)
    try {
      // @ts-expect-error TS(2339): Property 'setUserDireccion' does not exist on type...
      await props.setUserDireccion(data)
    } catch (e) {
      setSubmitting(false)
    }
    setSubmitting(false)
  },
})(Direccion)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setUserDireccion: (direccion: $TSMigrationFixMe) =>
    dispatch(createDireccionEmpresa(direccion)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  // TODO: Endpoint. empresaActiva podría tener propiedades como direccion, pais, email, telefono, etc.
  direccion: userSelector(state).empresaActiva,

  pais: userSelector(state).empresaActiva.pais,
})

export default connect(mapStateToProps, mapDispatchToProps)(DireccionWithFormik)
